import Section from '../components/Section';
import Button from '../components/Button';

const SummitApp = () => {
  return (
    <>
      {/* Page Header */}
      <section className="bg-summit-navy-dark text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold">Summit App</h1>
          <p className="text-xl text-gray-200 mt-4">
            Personal performance companion for car sales professionals
          </p>
        </div>
      </section>

      {/* Main Content */}
      <Section>
        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center mb-12">
            <div>
              <img 
                src="https://images.unsplash.com/photo-1768796370577-c6e8b708b980?w=800&q=80" 
                alt="Summit App" 
                className="rounded-sm shadow-lg"
              />
            </div>
            <div>
              <h2 className="text-3xl font-bold text-summit-navy-dark mb-6">What is Summit App?</h2>
              <p className="text-summit-grey leading-relaxed mb-4">
                Summit App is a personal performance companion designed specifically for car sales professionals.
              </p>
              <p className="text-summit-grey leading-relaxed mb-4">
                It is independent of dealership systems and focused entirely on individual performance tracking, motivation, and professional development.
              </p>
              <p className="text-summit-grey leading-relaxed">
                Built by automotive professionals for automotive professionals.
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-gray-200 my-12"></div>

          <div className="mb-12">
            <h2 className="text-3xl font-bold text-summit-navy-dark mb-8 text-center">Key Features</h2>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="bg-gray-50 p-6 rounded-sm">
                <h3 className="text-xl font-semibold text-summit-navy mb-3">📊 Daily Performance Tracking</h3>
                <p className="text-summit-grey">
                  Log sales activity, track conversions, and monitor personal performance metrics in real time.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-sm">
                <h3 className="text-xl font-semibold text-summit-navy mb-3">🏆 League Tables & Motivation</h3>
                <p className="text-summit-grey">
                  Compare your performance against peers, celebrate wins, and stay motivated through friendly competition.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-sm">
                <h3 className="text-xl font-semibold text-summit-navy mb-3">👥 Community & Networking</h3>
                <p className="text-summit-grey">
                  Connect with other sales professionals, share best practice, and build your automotive network.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-sm">
                <h3 className="text-xl font-semibold text-summit-navy mb-3">📰 Industry News & Insights</h3>
                <p className="text-summit-grey">
                  Stay informed with the latest automotive industry news, trends, and market intelligence.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-sm">
                <h3 className="text-xl font-semibold text-summit-navy mb-3">💼 Job Opportunities</h3>
                <p className="text-summit-grey">
                  Access exclusive automotive sales job opportunities and take control of your career progression.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-sm">
                <h3 className="text-xl font-semibold text-summit-navy mb-3">📱 Mobile-First Design</h3>
                <p className="text-summit-grey">
                  Designed for on-the-go professionals. Track performance anytime, anywhere.
                </p>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="border-t border-gray-200 my-12"></div>

          <div className="mb-12">
            <h2 className="text-3xl font-bold text-summit-navy-dark mb-6">Independent Platform</h2>
            <p className="text-summit-grey leading-relaxed mb-4">
              Summit App operates independently of dealership systems. Your performance data is yours.
            </p>
            <p className="text-summit-grey leading-relaxed mb-4">
              Whether you're looking to track personal development, benchmark your performance, or explore new career opportunities, Summit App provides the tools and community to support your success.
            </p>
          </div>

          {/* CTA */}
          <div className="bg-summit-navy text-white p-8 rounded-sm text-center">
            <h2 className="text-2xl font-bold mb-4">Ready to Elevate Your Performance?</h2>
            <p className="mb-6">Visit Summit App to learn more and get started.</p>
            <a 
              href="https://summitapp.co.uk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block px-8 py-3 bg-summit-gold text-summit-navy-dark font-semibold rounded-sm hover:bg-summit-gold-light transition-all duration-300"
            >
              Visit Summit App
            </a>
          </div>
        </div>
      </Section>

      {/* Divider */}
      <div className="border-t border-gray-200"></div>

      {/* Note */}
      <Section background="grey">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-summit-grey italic">
            Summit App is a separate product from Summit Motor Consultancy Group Limited. 
            For dealership consultancy services, please see our <a href="/services" className="text-summit-navy underline hover:text-summit-gold">Services</a> page.
          </p>
        </div>
      </Section>
    </>
  );
};

export default SummitApp;